module.exports = __webpack_public_path__ + "img/cloud-rain-2-sun-2.c8448f8a.svg";